<div class="content" style="min-height: 90vh; background-color: #f2f2f2;">
  <app-header></app-header>
  <app-content></app-content>
</div>
    <app-footer></app-footer>
   
